import { render } from "./CostTable.vue?vue&type=template&id=63060b8f&scoped=true"
import script from "./CostTable.vue?vue&type=script&lang=js"
export * from "./CostTable.vue?vue&type=script&lang=js"

import "./CostTable.vue?vue&type=style&index=0&id=63060b8f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63060b8f"]])

export default __exports__